import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import sv from './translations/sv.json';
import en from './translations/en.json';

export async function initI18n(): Promise<void> {
  const i18nInstance = i18n.use(LanguageDetector).use(initReactI18next);

  await i18nInstance.init({
    fallbackLng: 'en',
    resources: {
      en: {
        translation: en,
      },
      sv: {
        translation: sv,
      },
    },
    react: { useSuspense: false },
    supportedLngs: ['en', 'sv'],
    load: 'languageOnly',
    preload: ['en', 'sv'],
    defaultNS: 'translation',
    detection: {
      order: [
        'localStorage',
        'navigator',
        'querystring',
        'cookie',
        'sessionStorage',
        'htmlTag',
        'path',
        'subdomain',
      ],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });
}
